import gameState from "slotworks/model/game-state";
import ICSpinRecord from "integration/revolver/schema/spin-record";
import soundManager from "slotworks/sound/sound-manager";

import { HideAllLinesCommand } from "slotworks/commands/lines/hide-all-lines-command";
import { ShowLinesCommand } from "slotworks/commands/lines/show-lines-command";
import Components from "slotworks/components/components";
import AllWinsMediator from "slotworks/mediators/all-wins-mediator";
import AutoplayModel from "slotworks/model/autoplay-model";
import GameState from "slotworks/model/game-state";
import FreespinRecord from "slotworks/model/gameplay/records/freespin-record";
import Record from "slotworks/model/gameplay/records/record";
import LineResult from "slotworks/model/gameplay/records/results/line-result";
import State from "slotworks/state-machine/states/state";
import { parallel } from "slotworks/utils/race-utils";
import Timer from "slotworks/utils/timer";
import ICFreespinRecord from "integration/revolver/schema/freespin-record";
import regulation from "slotworks/integration/revolver/regulations/regulation";
import settingsModel from "slotworks/model/settings/settings-model";
import RevolverSettings from "model/revolver-settings";

export default class ICShowWinLines extends State {
    public static MULTILINE_ONLY: boolean = false;
    public static WIN_TICK_TIME: number = 750;
    public static END_DELAY: number = 0;

    private onDisplayComplete: Function;

    public onExit() {
        if(!gameState.getCurrentGame().inFreespinsGame) {
            if (RevolverSettings.winCount == 1) {
                soundManager.customEvent("base_win_progressive_1");
            } else {
                soundManager.customEvent("base_win_progressive_2");
            }
        }
    }

    public onEnter() {
        const record = gameState.getCurrentGame().getCurrentRecord();
        let inFreespins: boolean;
        if (RevolverSettings.resetTimer) clearTimeout(RevolverSettings.resetTimer);
        if (record instanceof ICSpinRecord) {
            // base game
            RevolverSettings.winCount++
            if (RevolverSettings.winCount == 1) {
                soundManager.customEvent("base_win_progressive_1_soft");
            } else {
                soundManager.customEvent("base_win_progressive_2_soft");
            }
            RevolverSettings.lastWinTime = Date.now();
            // RevolverSettings.resetTimer = setTimeout(() => {
            //     RevolverSettings.winCount = 0;
            //     soundManager.customEvent("enter_scene_MatrixForeground_default");
            // }, 10000);
            inFreespins = false;
        } else {
            // freespins game
            soundManager.customEvent("freespin_win_lines");
            inFreespins = true;
        }

        const results = record.results;
        const lines = [];

        const totalWin = inFreespins ? GameState.getCurrentGame().getRunningFreespinsWinTotal() : GameState.getCurrentGame().totalCreditsWon;

        for (const result of results) {
            if (result instanceof LineResult) {
                lines.push(result.line);
            }
        }
        // only coin win
        if (lines.length === 0) {
            Components.betBar.winnings.setWinnings(record.creditsWon, totalWin, 0);
            regulation.updateNetPosition(GameState.getNetPosition());
            this.complete();
            return;
        }

        if (this.hasOneLine(lines) && (this.onlyShowOnMultipleWinLines(record) ||
            (settingsModel.isUKJurisdiction() && // if we have one line win and no freespin or wheel is triggered
                !GameState.getCurrentGame().isWinAboveBet() && !inFreespins &&
                !record.freespinsTriggered && !record.isBonusTriggered("BONUS")))) {
            Components.betBar.winnings.setWinnings(record.creditsWon, totalWin, 0);
            this.complete();
            return;
        }

        ShowLinesCommand(lines).execute();

        const raceFuncs = [];

        // credits won minus amount won from coins
        const icrecord = gameState.getCurrentGame().getCurrentRecord() as ICSpinRecord | ICFreespinRecord;
        let creditsWon = record.creditsWon - icrecord.instantWin;
        if (this.allWinsAreSameSymbol(record) && this.isAutospinsOrFreespins(record)) {
            const result = results[0] as LineResult;
            if (result) {
                raceFuncs.push(() => Components.celebrateWin.singleTotalWin(creditsWon, result));
            }
        } else {
            raceFuncs.push(() => Components.celebrateWin.totalWin(creditsWon));
        }

        const allWinsMediator = new AllWinsMediator();
        raceFuncs.push(() => allWinsMediator.start());

        this.onDisplayComplete = () => {
            this.onDisplayComplete = null;
            allWinsMediator.end();
            HideAllLinesCommand().execute();
            Components.celebrateWin.hide();
            Components.betBar.winnings.setWinnings(record.creditsWon, totalWin, ICShowWinLines.WIN_TICK_TIME);
            regulation.updateNetPosition(GameState.getNetPosition());
        };

        parallel(raceFuncs).then(() => {
            Timer.setTimeout(() => {
                if (this.onDisplayComplete) {
                    this.onDisplayComplete();
                    this.complete();
                }
            }, ICShowWinLines.END_DELAY);
        });
    }

    public onSkip() {
        if (this.onDisplayComplete) {
            this.onDisplayComplete();
        }
        this.skip();
    }

    private allWinsAreSameSymbol(record: Record) {
        const symbolTypes: string[] = [];
        for (const result of record.results) {
            if (result instanceof LineResult) {
                symbolTypes.push(result.symbolType);
            }
        }

        return symbolTypes.every((v) => v === symbolTypes[0]);
    }

    private hasOneLine(lines: number[]) {
        return lines.length <= 1;
    }

    private isAutospinsOrFreespins(record: Record) {
        return (record instanceof FreespinRecord) || AutoplayModel.isAutoPlaying();
    }

    private onlyShowOnMultipleWinLines(record: Record) {
        return !this.isAutospinsOrFreespins(record) && ICShowWinLines.MULTILINE_ONLY;
    }
}